import type { IPartFilter } from "@contentful-api/types/contentful";
import { TARGET_GROUP_FACET } from "@lib/constants/filtersConstants";

export const hasTargetGroupFilter = (listOfFilters: IPartFilter[]) =>
    listOfFilters?.some((filter) => filter?.fields?.facetName === TARGET_GROUP_FACET) ?? false;
